/* eslint-disable react/prop-types */
import { useState } from 'react'
import styled from 'styled-components'
import ReactMarkdown from 'react-markdown'
import { commentComments } from 'common/post/md-renderer'
import CommentForm from 'components/comment/form/'
import AuthorComment from 'components/comment/autor-comment'
import { decodeComment } from 'utils/parse-comment'
import ReactionsList from './reactions'
import CommentContent from './comment-content-styled'

const CommentStyled = styled.article`
  ${({ isReply }) => !isReply && 'border-bottom: 1px solid #ffffff33;'}
  /* padding: 16px 0; */
  ${({ isReply }) => (!isReply ? 'padding: 16px 0;' : 'margin: 16px 0;')}
  &:last-of-type{
    border-bottom: none;
  }
  .comment-wrapper {
    padding-left: 40px;
  }
  @media screen and (min-width: 1024px) {
    ${({ isReply }) => (!isReply ? 'padding: 24px 0;' : 'margin: 16px 0;')}
    max-width: calc(100vw - 398px);
  }
`

function CommonDetail({
  uuid: commentId,
  isReply,
  refElement,
  author,
  created_at,
  onDelete,
  content,
  children,
  likes,
  wands,
  nogiveups,
  reactions,
  onReaction,
  participants,
}) {
  const [replyActive, setReplyActive] = useState(false)
  function handleReplyForm() {
    setReplyActive(!replyActive)
  }
  return (
    <CommentStyled ref={refElement} data-cy="comment" isReply={isReply} id={commentId}>
      <AuthorComment
        author={author}
        commentId={commentId}
        isReply={isReply}
        created_at={created_at}
        onDelete={onDelete}
      />
      <div className="comment-wrapper">
        <CommentContent className="comment-text">
          {content.blocks.map((block, index) => {
            const text = block?.data?.text
            return (
              <ReactMarkdown
                components={commentComments}
                key={block?.data?.text}
              >
                {decodeComment(text, participants)}
              </ReactMarkdown>
            )
          })}
        </CommentContent>
        <ReactionsList
          handleReplyForm={handleReplyForm}
          replyActive={replyActive}
          isReply={isReply}
          reactionsCounter={{ likes, wands, nogiveups }}
          reactions={reactions}
          onReaction={onReaction}
        />
        {(replyActive && !isReply) && (
          <CommentForm
            handleActive={handleReplyForm}
            parent={commentId}
            cta="Responder"
            placeholder="Escribe una respuesta..."
            participants={participants}
            autofocus
          />
        )}
        {/* THIS IS THE REPLY LIST */}
        {children}
      </div>
    </CommentStyled>
  )
}

export default CommonDetail
